import DayJsUtil from './DayJSUtils';
;
;
export default class SpecialEventUtils {
    /**
     * getSpecialEventItems - Parses the specialEventItemsAvailability data so that
     * nextAvailable time and overall availability can be determined
     *
     * @param {Object} parsedResponse - {id: { time: stock}}, returns all times and item stock for each product
     * @param {string} selectedTime - Customer's currently selected time
     * @return {ISpecialEventItemDetails[]} - [
     *  {
     *    id:String, \\ item id
     *    stock:number \\ item stock amount for current selected time
     *    available:Boolean, \\ true if there is at least one time slot with items available
     *    nextAvailable: String \\ time value w/ separator, Exp: "09:00", only not '' if the selectedTime has 0 items
     *  }
     * ]
     */
    static getSpecialEventItems(parsedResponse, selectedTime) {
        const specialEventItems = [];
        const specialEventResponse = parsedResponse;
        for (const [itemId, times] of Object.entries(specialEventResponse)) {
            const item = {
                id: itemId,
                stock: times[selectedTime] || 0,
                available: !this.allItemStocksEmpty(Object.values(times)) || false,
                nextAvailable: '',
            };
            if (item.available) {
                const nextAvailable = this.closestTimeInStock(selectedTime, times);
                item.nextAvailable = nextAvailable ? DayJsUtil.addTimeSeparator(nextAvailable) : nextAvailable;
            }
            specialEventItems.push(item);
        }
        return specialEventItems;
    }
    /**
     * allItemStocksEmpty - Checks to see if the item stock is 0 for all time slots
     *
     * @param {Array} itemStocks - [Number], takes in array numbers in this case all item stocks
     * @return {boolean} true if item stock is 0 for all time slots
     */
    static allItemStocksEmpty(itemStocks) {
        return itemStocks.every((stock) => stock === itemStocks[0] && stock === 0);
    }
    /**
     * closestTimeInStock: Returns the closest time with stock, defaults to '' if stock is not 0
     * @param {string} selectedTime - Customer's currently selected time
     * @param {ITimeSlots} timeSlots - Exp: {{'0900':0},...}, contains the stock level for each time slot
     * @returns string - next closest time with item stock available
     */
    static closestTimeInStock(selectedTime, timeSlots) {
        const allTimeSlots = timeSlots;
        if (allTimeSlots[selectedTime] > 0) {
            return '';
        }
        // convert times to decimal for comparison, f/x: "0945" -> 9.75
        const getDecimalTime = (time) => parseInt(time.substring(0, 2)) + parseInt(time.substring(2)) / 60;
        const selectedTimeDecimal = getDecimalTime(selectedTime);
        // initialize the closest time and difference
        let closestTime = '';
        let lowestTimeDifference = Infinity;
        for (const [time, stock] of Object.entries(allTimeSlots)) {
            const timeDecimal = getDecimalTime(time);
            const timeDifference = Math.abs(selectedTimeDecimal - timeDecimal);
            // if this time is a closer time, or
            // if this time is equally close, and has the same or more stock
            if ((stock > 0 && timeDifference < lowestTimeDifference) ||
                (timeDifference === lowestTimeDifference && stock >= allTimeSlots[closestTime])) {
                closestTime = time;
                lowestTimeDifference = timeDifference;
            }
        }
        return closestTime;
    }
}
